module.exports = __webpack_public_path__ + "img/treatment-extend.b3555e97.png";